import { SettingsPanelActionTypes, SET_KEYS } from "./types";

export const setSettingsKeys = (ss: string[]): SettingsPanelActionTypes => {
  return {
    type: SET_KEYS,
    meta: {
      params: {
        setSettingsPanelActiveKeys: ss
      }
    }
  };
};

export type SetKeysAction = typeof setSettingsKeys;
